import React from 'react';

export default function ArrowIcon({ className }) {
  return (
    <svg
      class={`${className} ms-1 rtl:rotate-180`}
      aria-hidden="true"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        stroke="currentColor"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-width="2"
        d="M19 12H5m14 0-4 4m4-4-4-4"
      />
    </svg>
  );
}
